import type React from 'react';

/** A plain left click (no modifier keys), i.e. one a router link handles in the current tab. */
export const isPlainLeftClick = (e: React.MouseEvent) =>
  e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

/**
 * onClick for the link of the tab that's already selected: a plain click stays a no-op (as it was with
 * MUI Tabs onChange, which skips the active tab) instead of re-navigating to the tab's bare path and
 * dropping anything else in the URL. Modified / middle clicks still open the link in a new tab.
 */
export const ignorePlainClick = (e: React.MouseEvent) => {
  if (isPlainLeftClick(e)) e.preventDefault();
};
